module.exports = __webpack_public_path__ + "static/media/success-message.013dd4f4.svg";